<div class="min-h-screen bg-slate-50 text-slate-900 dark:bg-[#09090b] dark:text-slate-100 flex flex-col antialiased selection:bg-emerald-600 selection:text-white transition-colors duration-200">
  <header class="border-b border-slate-200 dark:border-slate-800 bg-white/80 dark:bg-slate-900/80 backdrop-blur px-4 py-3 flex items-center justify-between shadow-xs">
    <div class="flex items-center space-x-2">
      <span class="w-2.5 h-2.5 rounded-full bg-emerald-600 animate-pulse"></span>
      <span class="text-xs font-bold tracking-wider uppercase text-slate-700 dark:text-slate-300">
        League of Managers
      </span>
    </div>

    <div class="relative">
      <!-- Settings Wheel / User Menu Button -->
      <button
        type="button"
        (click)="toggleUserMenu()"
        id="btn-league-settings"
        [title]="game.t('nav.settings')"
        class="flex items-center space-x-2 px-2.5 py-1.5 rounded-xl border border-slate-200 dark:border-slate-700/60 bg-white/80 dark:bg-slate-900/80 hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-700 dark:text-slate-200 transition-colors cursor-pointer shadow-xs"
      >
        <div class="w-6 h-6 rounded-lg bg-gradient-to-tr from-emerald-600 to-teal-500 text-white flex items-center justify-center font-bold text-xs shrink-0 shadow-xs">
          {{ game.currentUser()?.name?.charAt(0) || 'M' }}
        </div>
        <span class="hidden sm:inline text-xs font-semibold text-slate-800 dark:text-slate-200">
          {{ game.currentUser()?.name || 'Mánager' }}
        </span>
        <app-icon name="settings" [size]="15" class="text-slate-500 dark:text-slate-400" />
      </button>

      @if (isUserMenuOpen()) {
        <!-- Backdrop click overlay -->
        <div (click)="closeUserMenu()" class="fixed inset-0 z-40"></div>

        <div id="league-user-menu-dropdown" class="absolute right-0 mt-2 w-72 sm:w-80 bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-2xl shadow-xl py-2 z-50 text-xs transition-colors">
          <!-- Info de usuario -->
          @if (game.currentUser(); as user) {
            <div class="px-3.5 py-2.5 border-b border-slate-100 dark:border-slate-800">
              <div class="flex items-center space-x-2.5">
                <div class="w-8 h-8 rounded-xl bg-gradient-to-tr from-emerald-600 to-teal-500 text-white flex items-center justify-center font-bold text-sm shadow-xs shrink-0">
                  {{ user.name.charAt(0) || 'M' }}
                </div>
                <div class="min-w-0 flex-1">
                  <p class="font-bold text-slate-900 dark:text-white truncate">{{ user.name }}</p>
                  <p class="text-[11px] text-slate-500 dark:text-slate-400 truncate">{{ user.email }}</p>
                </div>
              </div>
              <div class="mt-2 flex items-center justify-between">
                <span class="inline-block px-1.5 py-0.5 rounded text-[10px] font-semibold bg-emerald-50 text-emerald-700 border border-emerald-200 dark:bg-emerald-950 dark:text-emerald-400 dark:border-emerald-800/60">
                  {{ user.role }}
                </span>
                @if (game.userClub(); as club) {
                  <span class="text-[11px] text-slate-500 dark:text-slate-400 truncate max-w-[150px] flex items-center space-x-1 font-medium">
                    <span class="w-2 h-2 rounded-full shrink-0" [style.backgroundColor]="club.primaryColor"></span>
                    <span class="truncate">{{ club.name }}</span>
                  </span>
                }
              </div>
            </div>
          }

          <!-- Apartado de Wallet del Mánager (CR) en Settings 
          <div class="p-3 mx-2 my-1.5 rounded-xl bg-gradient-to-br from-amber-500/10 to-orange-500/10 dark:from-amber-950/50 dark:to-orange-950/30 border border-amber-200/90 dark:border-amber-800/60">
            <div class="flex items-center justify-between">
              <div class="flex items-center space-x-1.5">
                <app-icon name="coins" [size]="15" class="text-amber-600 dark:text-amber-400" />
                <span class="font-bold text-[11px] text-amber-900 dark:text-amber-200">
                  {{ game.t('settings.wallet_title') }}
                </span>
              </div>
              <span class="font-mono font-bold text-amber-700 dark:text-amber-300 text-xs px-2 py-0.5 rounded-md bg-white/90 dark:bg-slate-900 border border-amber-200/80 dark:border-amber-800/50 shadow-2xs">
                {{ game.userClub().economy.subscriptionCredits }} CR
              </span>
            </div>
            <p class="text-[10px] text-amber-800/80 dark:text-amber-300/70 mt-1 leading-tight">
              Saldo personal para cuota mensual de licencia (100 CR/mes) y torneos.
            </p>
            <div class="mt-2.5 flex items-center space-x-1.5">
              <button
                type="button"
                (click)="openSettingsModal()"
                id="league-menu-btn-open-wallet"
                class="flex-1 py-1.5 px-2 bg-amber-600 hover:bg-amber-700 text-white rounded-lg font-semibold text-[11px] flex items-center justify-center space-x-1 cursor-pointer shadow-xs transition-colors"
              >
                <span>Gestionar Wallet</span>
                <app-icon name="chevron-right" [size]="12" />
              </button>
              <button
                type="button"
                (click)="paySubscription()"
                id="league-menu-btn-pay-quick-cr"
                class="py-1.5 px-2 bg-white dark:bg-slate-900 hover:bg-amber-100 dark:hover:bg-amber-900/40 text-amber-800 dark:text-amber-300 border border-amber-300 dark:border-amber-700/60 rounded-lg font-semibold text-[11px] cursor-pointer transition-colors"
                title="Abonar cuota mensual (-100 CR)"
              >
                -100 CR
              </button>
            </div>
          </div>-->

          <div class="p-1 space-y-0.5">
            <!-- Abrir Todos los Ajustes -->
            <button
              type="button"
              (click)="openSettingsModal()"
              id="league-menu-open-all-settings"
              class="w-full flex items-center justify-between px-3 py-2 rounded-xl text-slate-700 dark:text-slate-200 hover:bg-slate-100 dark:hover:bg-slate-800 cursor-pointer transition-colors"
            >
              <div class="flex items-center space-x-2.5">
                <app-icon name="settings" [size]="16" class="text-slate-500 dark:text-slate-400" />
                <span class="font-medium">{{ game.t('settings.title') }}</span>
              </div>
              <app-icon name="chevron-right" [size]="14" class="text-slate-400" />
            </button>

            <!-- Modo Oscuro / Claro -->
            <button
              type="button"
              (click)="game.toggleDarkMode()"
              id="league-menu-theme"
              class="w-full flex items-center justify-between px-3 py-2 rounded-xl text-slate-700 dark:text-slate-200 hover:bg-slate-100 dark:hover:bg-slate-800 cursor-pointer transition-colors"
            >
              <div class="flex items-center space-x-2.5">
                @if (game.isDarkMode()) {
                  <app-icon name="sun" [size]="16" class="text-amber-400" />
                  <span class="font-medium">{{ game.t('nav.toggle_theme_light') }}</span>
                } @else {
                  <app-icon name="moon" [size]="16" class="text-slate-600 dark:text-slate-300" />
                  <span class="font-medium">{{ game.t('nav.toggle_theme_dark') }}</span>
                }
              </div>
              <div class="w-8 h-4.5 rounded-full p-0.5 transition-colors" [ngClass]="game.isDarkMode() ? 'bg-emerald-600' : 'bg-slate-300 dark:bg-slate-700'">
                <div class="w-3.5 h-3.5 rounded-full bg-white transition-transform" [ngClass]="game.isDarkMode() ? 'translate-x-3.5' : 'translate-x-0'"></div>
              </div>
            </button>

            <!-- Cambiar Idioma 
            <div class="pt-1 border-t border-slate-100 dark:border-slate-800">
              <div class="px-3 py-1 text-[10px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider flex items-center justify-between">
                <span class="flex items-center space-x-1.5">
                  <app-icon name="globe" [size]="12" />
                  <span>{{ game.t('nav.language') }}</span>
                </span>
                <span class="font-mono text-[10px] text-emerald-600 dark:text-emerald-400 font-semibold">{{ game.i18n.currentLanguageOption().shortCode }}</span>
              </div>

              <div class="grid grid-cols-2 gap-1 px-1.5 py-1">
                @for (lang of game.i18n.availableLanguages; track lang.code) {
                  <button
                    type="button"
                    (click)="selectLanguage(lang.code)"
                    [id]="'league-menu-lang-' + lang.code"
                    class="flex items-center space-x-1.5 px-2 py-1.5 rounded-lg text-left cursor-pointer transition-colors"
                    [ngClass]="game.i18n.currentLanguage() === lang.code ? 'bg-emerald-50 dark:bg-emerald-950/50 text-emerald-700 dark:text-emerald-400 font-bold border border-emerald-200 dark:border-emerald-800/60' : 'text-slate-600 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-800 border border-transparent'"
                  >
                    <span class="text-sm leading-none">{{ lang.flag }}</span>
                    <span class="text-[11px] truncate">{{ lang.nativeName }}</span>
                  </button>
                }
              </div>
            </div>-->

            <!-- Cerrar Sesión -->
            @if (game.currentUser()) {
              <div class="pt-1 border-t border-slate-100 dark:border-slate-800">
                <button
                  type="button"
                  (click)="handleLogout()"
                  id="league-menu-logout"
                  class="w-full flex items-center space-x-2.5 px-3 py-2 rounded-xl text-rose-600 dark:text-rose-400 hover:bg-rose-50 dark:hover:bg-rose-950/40 cursor-pointer transition-colors font-semibold"
                >
                  <app-icon name="log-out" [size]="15" />
                  <span>{{ game.t('nav.logout') }}</span>
                </button>
              </div>
            }
          </div>
        </div>
      }
    </div>
  </header>

  <main class="flex-1">
    <div class="max-w-6xl mx-auto py-6 px-4 sm:px-6 lg:px-8 space-y-8">
  <!-- Loading State -->
  @if (isLoading()) {
    <div class="space-y-6 animate-pulse">
      <div class="h-24 bg-slate-200 dark:bg-slate-800 rounded-2xl"></div>
      <div class="h-10 w-64 bg-slate-200 dark:bg-slate-800 rounded-xl"></div>
      <div class="h-44 bg-slate-200 dark:bg-slate-800 rounded-2xl"></div>
    </div>
  }

  <!-- Error State -->
  @if (!isLoading() && errorMessage()) {
    <div class="bg-rose-50 dark:bg-rose-950/40 border border-rose-200 dark:border-rose-900/50 rounded-2xl p-5 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
      <div class="flex items-center space-x-3">
        <div class="w-10 h-10 rounded-xl bg-rose-600 text-white flex items-center justify-center shrink-0">
          <app-icon name="alert-circle" [size]="20" />
        </div>
        <div>
          <h4 class="text-sm font-bold text-rose-900 dark:text-rose-200">
            {{ game.t('leagues.error_title') }}
          </h4>
          <p class="text-xs text-rose-700 dark:text-rose-300 mt-0.5">
            {{ errorMessage() }}
          </p>
        </div>
      </div>
      <button
        type="button"
        (click)="loadData()"
        class="px-4 py-2 rounded-xl text-xs font-semibold text-white bg-rose-600 hover:bg-rose-700 transition-colors cursor-pointer shrink-0"
      >
        {{ game.t('common.retry') }}
      </button>
    </div>
  }

  <!-- Main Content When Loaded -->
  @if (!isLoading()) {
    <!-- Active Game Alert (if user has active club) -->
    @if (isJoined() && activeClubName()) {
      <div class="bg-gradient-to-r from-emerald-500/10 via-teal-500/10 to-blue-500/10 border border-emerald-500/30 rounded-2xl p-4 sm:p-5 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 shadow-xs">
        <div class="flex items-center space-x-3.5">
          <div class="w-10 h-10 rounded-xl bg-emerald-600 text-white flex items-center justify-center shrink-0 shadow-xs">
            <app-icon name="shield" [size]="20" />
          </div>
          <div>
            <div class="flex items-center space-x-2">
              <span class="text-xs font-bold uppercase tracking-wider text-emerald-700 dark:text-emerald-400">
                {{ game.t('leagues.active_game') }}
              </span>
              <span class="text-xs font-bold text-slate-900 dark:text-white">
                · {{ seasonName() }}
              </span>
            </div>
            <p class="text-xs text-slate-600 dark:text-slate-300 mt-0.5">
              {{ game.t('leagues.managing_club') }} <strong class="text-slate-900 dark:text-white">{{ activeClubName() }}</strong>
              @if (hasValidMatchdays()) {
                ({{ game.t('comp.round_prefix') }} {{ currentMatchday() }}/{{ totalMatchdays() }}).
              }
            </p>
          </div>
        </div>
        <button
          type="button"
          (click)="handleEnterClub()"
          id="btn-resume-active-league"
          class="flex items-center space-x-2 px-5 py-2.5 rounded-xl text-xs font-bold text-white bg-emerald-600 hover:bg-emerald-700 active:bg-emerald-800 transition-all shadow-xs cursor-pointer"
        >
          <span>{{ game.t('leagues.resume_game') }}</span>
          <app-icon name="arrow-right" [size]="16" />
        </button>
      </div>
    }

    <!-- Header Explanatory Title -->
    <div class="text-center sm:text-left space-y-2">
      <h1 class="text-2xl sm:text-3xl font-extrabold text-slate-900 dark:text-white tracking-tight">
        {{ game.t('leagues.my_competitions') }}
      </h1>
      <p class="text-sm text-slate-600 dark:text-slate-400 max-w-3xl">
        {{ game.t('leagues.selection_desc') }}
      </p>
    </div>

    <!-- Global League Section -->
    <div class="space-y-4">
      <div class="flex items-center justify-between">
        <div class="flex items-center space-x-2">
          <app-icon name="globe" [size]="18" class="text-blue-600 dark:text-blue-400" />
          <h3 class="text-base font-bold text-slate-900 dark:text-white uppercase tracking-wider">
            {{ game.t('leagues.official_competition') }}
          </h3>
        </div>
        <span class="text-xs text-slate-500 font-mono">1 {{ game.t('leagues.main_league') }}</span>
      </div>

      <!-- State: JOINED -->
      @if (isJoined()) {
        <div class="bg-white dark:bg-slate-900 border border-blue-200 dark:border-blue-800/40 hover:border-blue-400 dark:hover:border-blue-600/70 rounded-2xl p-6 transition-all shadow-xs dark:shadow-xl relative overflow-hidden group">
          <div class="flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
            <div class="flex items-start space-x-4">
              <div class="w-14 h-14 rounded-2xl bg-blue-50 dark:bg-blue-600/20 border border-blue-200 dark:border-blue-500/30 flex items-center justify-center shrink-0">
                <app-icon name="trophy" [size]="28" class="text-blue-600 dark:text-blue-400" />
              </div>
              <div>
                <div class="flex flex-wrap items-center gap-2">
                  <h4 class="text-xl font-bold text-slate-900 dark:text-white">{{ seasonName() }}</h4>
                  <span class="px-2 py-0.5 rounded-lg text-xs font-bold bg-blue-50 text-blue-700 border border-blue-200 dark:bg-blue-500/20 dark:text-blue-300 dark:border-blue-500/30">
                    {{ game.t('leagues.official_badge') }}
                  </span>
                  @if (format()) {
                    <span class="px-2 py-0.5 rounded-lg text-xs font-bold bg-purple-50 text-purple-700 border border-purple-200 dark:bg-purple-500/20 dark:text-purple-300 dark:border-purple-500/30">
                      {{ format() }}
                    </span>
                  }
                </div>
                <p class="text-sm text-slate-600 dark:text-slate-300 mt-1">
                  {{ divisionName() || game.t('leagues.global_competition') }}
                </p>
                <div class="flex flex-wrap items-center gap-4 mt-3 text-xs text-slate-500 dark:text-slate-400">
                  @if (divisionName()) {
                    <span class="flex items-center space-x-1">
                      <app-icon name="trophy" [size]="14" />
                      <span>{{ divisionName() }}</span>
                    </span>
                  }
                  @if (teamCountText()) {
                    <span class="flex items-center space-x-1">
                      <app-icon name="users" [size]="14" />
                      <span>{{ teamCountText() }}</span>
                    </span>
                  }
                  @if (cycleText()) {
                    <span class="flex items-center space-x-1 text-purple-600 dark:text-purple-400 font-semibold">
                      <app-icon name="rotate-cw" [size]="14" />
                      <span>{{ cycleText() }}</span>
                    </span>
                  }
                  @if (hasValidMatchdays()) {
                    <span class="flex items-center space-x-1">
                      <app-icon name="calendar" [size]="14" />
                      <span>{{ game.t('comp.round_prefix') }} {{ currentMatchday() }}/{{ totalMatchdays() }}</span>
                    </span>
                  }
                  @if (activeClubName()) {
                    <span class="flex items-center space-x-1 text-emerald-700 dark:text-emerald-400 font-semibold">
                      <app-icon name="shield" [size]="14" />
                      <span>{{ game.t('leagues.your_club') }}: {{ activeClubName() }}</span>
                    </span>
                  }
                </div>
              </div>
            </div>

            <div class="w-full md:w-auto flex flex-col sm:flex-row items-center gap-3">
              <button
                type="button"
                (click)="handleEnterClub()"
                id="btn-select-league-global"
                [disabled]="game.isLeagueLoading()"
                class="w-full sm:w-auto flex items-center justify-center space-x-2 px-6 py-3 rounded-xl text-sm font-semibold text-white bg-blue-600 hover:bg-blue-700 active:bg-blue-800 transition-all shadow-xs cursor-pointer disabled:opacity-50 active:scale-98"
              >
                <span>{{ game.t('leagues.enter_club') }}</span>
                <app-icon name="arrow-right" [size]="16" />
              </button>
            </div>
          </div>
        </div>
      } @else {
        <!-- State: NOT_JOINED -->
        <div class="bg-white dark:bg-slate-900 border border-blue-200 dark:border-blue-800/40 rounded-2xl p-6 transition-all shadow-xs dark:shadow-xl relative overflow-hidden">
          <div class="flex flex-col md:flex-row items-start space-y-4 md:space-y-0 md:space-x-4">
            <div class="w-14 h-14 rounded-2xl bg-blue-50 dark:bg-blue-600/20 border border-blue-200 dark:border-blue-500/30 flex items-center justify-center shrink-0">
              <app-icon name="trophy" [size]="28" class="text-blue-600 dark:text-blue-400" />
            </div>
            <div class="flex-1 w-full">
              <div class="flex flex-wrap items-center gap-2">
                <h4 class="text-xl font-bold text-slate-900 dark:text-white">{{ seasonName() }}</h4>
                <span class="px-2 py-0.5 rounded-lg text-xs font-bold bg-blue-50 text-blue-700 border border-blue-200 dark:bg-blue-500/20 dark:text-blue-300 dark:border-blue-500/30">
                  {{ game.t('leagues.official_badge') }}
                </span>
                @if (canJoin()) {
                  <span class="px-2 py-0.5 rounded-lg text-xs font-bold bg-emerald-50 text-emerald-700 border border-emerald-200 dark:bg-emerald-950 dark:text-emerald-400 dark:border-emerald-800/60">
                    {{ game.t('leagues.join_open') }}
                  </span>
                } @else {
                  <span class="px-2 py-0.5 rounded-lg text-xs font-bold bg-amber-50 text-amber-700 border border-amber-200 dark:bg-amber-950 dark:text-amber-400 dark:border-amber-800/60">
                    {{ game.t('leagues.join_closed') }}
                  </span>
                }
              </div>
              <p class="text-sm text-slate-600 dark:text-slate-300 mt-1">
                {{ game.t('leagues.official_desc') }}
              </p>

              @if (canJoin()) {
                <form (ngSubmit)="handleCreateClub()" class="mt-4 flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
                  <div class="relative flex-1">
                    <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-slate-400">
                      <app-icon name="shield" [size]="18" />
                    </div>
                    <input
                      id="input-global-club-name"
                      type="text"
                      [(ngModel)]="newClubName"
                      name="newClubName"
                      [disabled]="isSubmittingClub()"
                      [placeholder]="game.t('leagues.enter_club_placeholder')"
                      required
                      class="w-full pl-10 pr-4 py-3 bg-slate-50 dark:bg-slate-950 border border-slate-200 dark:border-slate-800 rounded-xl text-sm text-slate-900 dark:text-slate-100 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all disabled:opacity-60"
                    />
                  </div>
                  <button
                    type="submit"
                    id="btn-join-global-competition"
                    [disabled]="!newClubName.trim() || isSubmittingClub()"
                    class="flex items-center justify-center space-x-2 px-6 py-3 rounded-xl text-sm font-semibold text-white bg-blue-600 hover:bg-blue-700 active:bg-blue-800 transition-all shadow-xs cursor-pointer disabled:opacity-50 active:scale-98 shrink-0"
                  >
                    @if (isSubmittingClub()) {
                      <div class="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                      <span>{{ game.t('leagues.registering_club') }}</span>
                    } @else {
                      <span>{{ game.t('leagues.create_and_join') }}</span>
                      <app-icon name="plus" [size]="16" />
                    }
                  </button>
                </form>
              } @else {
                <div class="mt-3 p-3 bg-amber-50 dark:bg-amber-950/40 border border-amber-200 dark:border-amber-800/60 rounded-xl text-xs text-amber-800 dark:text-amber-300">
                  {{ game.t('leagues.registrations_not_open') }}
                </div>
              }
            </div>
          </div>
        </div>
      }
    </div>

    <!-- Private Leagues Section -->
    <section class="space-y-4 pt-4" aria-label="Ligas privadas con amigos">
      <div class="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
        <div class="flex items-center space-x-2">
          <app-icon name="lock" [size]="18" class="text-purple-600 dark:text-purple-400" />
          <h3 class="text-base font-bold text-slate-900 dark:text-white uppercase tracking-wider">
            Ligas Privadas con Amigos
          </h3>
          <span class="text-xs bg-slate-100 dark:bg-slate-800 text-slate-700 dark:text-slate-300 px-2.5 py-0.5 rounded-full font-bold border border-slate-200 dark:border-slate-700">
            {{ privateLeagues().length }}
          </span>
        </div>

        <div class="flex items-center space-x-2">
          <button
            type="button"
            [disabled]="!privateLeaguesEnabled()"
            (click)="showJoinModal = true"
            id="btn-open-join-league"
            aria-label="Unirme con invitación"
            class="flex items-center space-x-1.5 px-3 py-2 text-xs font-semibold text-slate-700 dark:text-slate-200 bg-slate-100 hover:bg-slate-200 dark:bg-slate-800 dark:hover:bg-slate-700 rounded-xl border border-slate-200 dark:border-slate-700 transition-colors cursor-pointer disabled:opacity-50"
          >
            <app-icon name="arrow-right" [size]="14" />
            <span>Unirse con Código</span>
          </button>
          <button
            type="button"
            [disabled]="!privateLeaguesEnabled()"
            (click)="showCreateModal = true"
            id="btn-open-create-league"
            aria-label="Crear liga privada"
            class="flex items-center space-x-1.5 px-3 py-2 text-xs font-semibold text-white bg-emerald-600 hover:bg-emerald-700 rounded-xl shadow-xs transition-colors cursor-pointer active:scale-98 disabled:opacity-50"
          >
            <app-icon name="plus" [size]="14" />
            <span>Crear Nueva Liga</span>
          </button>
        </div>
      </div>

      @if (!privateLeaguesEnabled()) {
        <p class="text-xs text-slate-500 dark:text-slate-400">
          La apertura de ligas privadas aún no está disponible en esta temporada.
        </p>
      }

      @if (competitionsState()?.privateLeaguesStatus === 'DISABLED') {
        <p role="status" class="text-xs text-slate-500 dark:text-slate-400">
          La consulta de ligas privadas está deshabilitada.
        </p>
      } @else if (privateLeagues().length === 0) {
        <div class="bg-white dark:bg-slate-900/60 border border-slate-200 dark:border-slate-800/80 rounded-2xl p-8 sm:p-10 text-center space-y-3 shadow-xs">
          <div class="w-12 h-12 mx-auto rounded-xl bg-slate-100 dark:bg-slate-800/80 border border-slate-200 dark:border-slate-700/60 flex items-center justify-center text-slate-400 dark:text-slate-400">
            <app-icon name="lock" [size]="22" />
          </div>
          <h4 class="text-base font-bold text-slate-900 dark:text-white">
            No perteneces a ninguna liga privada todavía
          </h4>
          <p class="text-xs text-slate-500 dark:text-slate-400 max-w-md mx-auto leading-relaxed">
            Crea tu propia liga de amigos para competir por jornada con normas y fichajes propios, o únete usando el código de invitación que te hayan facilitado.
          </p>
        </div>
      } @else {
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          @for (league of privateLeagues(); track (league.privateLeagueId || $index)) {
            <article class="bg-white dark:bg-slate-900/90 border border-slate-200 dark:border-slate-800 hover:border-purple-400 dark:hover:border-purple-600/50 rounded-2xl p-5 transition-all shadow-xs dark:shadow-lg flex flex-col justify-between space-y-4">
              <div>
                <div class="flex items-center justify-between gap-2">
                  <div class="flex items-center space-x-2.5 min-w-0">
                    <div class="w-8 h-8 rounded-lg bg-purple-50 dark:bg-purple-950/60 border border-purple-200 dark:border-purple-800/60 flex items-center justify-center shrink-0">
                      <app-icon name="shield" [size]="16" class="text-purple-600 dark:text-purple-400" />
                    </div>
                    <h4 class="text-base font-bold text-slate-900 dark:text-white truncate">{{ league.name }}</h4>
                  </div>
                  @if (league.code) {
                    <span class="text-[11px] font-mono font-bold text-purple-700 dark:text-purple-400 bg-purple-50 dark:bg-purple-950/50 px-2 py-0.5 rounded-lg border border-purple-200 dark:border-purple-900/40 shrink-0">
                      Código: {{ league.code }}
                    </span>
                  }
                </div>

                @if (league.description) {
                  <p class="text-xs text-slate-600 dark:text-slate-400 mt-2 line-clamp-2">{{ league.description }}</p>
                }

                <div class="flex flex-wrap items-center gap-3 mt-3 text-xs text-slate-500 dark:text-slate-400">
                  @if (league.club?.name || league.userClubName) {
                    <span class="text-emerald-700 dark:text-emerald-400 font-semibold flex items-center space-x-1">
                      <app-icon name="shield" [size]="14" />
                      <span>{{ league.club?.name || league.userClubName }}</span>
                    </span>
                  }
                  @if (league.totalClubs) {
                    <span class="flex items-center space-x-1">
                      <app-icon name="users" [size]="14" />
                      <span>{{ league.totalClubs }} Equipos</span>
                    </span>
                  }
                  @if (league.currentMatchdayNumber != null && league.totalMatchdays != null && league.totalMatchdays > 0) {
                    <span class="flex items-center space-x-1">
                      <app-icon name="calendar" [size]="14" />
                      <span>J{{ league.currentMatchdayNumber }}/{{ league.totalMatchdays }}</span>
                    </span>
                  }
                  @if (league.leagueState) {
                    <span class="px-2 py-0.5 rounded text-[10px] font-bold uppercase tracking-wider"
                      [ngClass]="league.leagueState === 'ACTIVE' ? 'bg-emerald-50 text-emerald-700 dark:bg-emerald-950/50 dark:text-emerald-400 border border-emerald-200 dark:border-emerald-800/60' : 'bg-amber-50 text-amber-700 dark:bg-amber-950/50 dark:text-amber-400 border border-amber-200 dark:border-amber-800/60'">
                      {{ league.leagueState === 'ACTIVE' ? 'Activa' : 'Borrador / Preparación' }}
                    </span>
                  }
                </div>

                @if (league.leagueState === 'CANCELLING' || league.leagueState === 'CANCELLED') {
                  <p class="mt-2 text-xs text-slate-500">{{league.leagueState === 'CANCELLED' ? 'Liga cancelada. Puedes consultar su historial.' : 'La cancelación está en curso; no se permiten nuevas acciones.'}}</p>
                } @else if (league.provisioning?.status === 'FAILED') {
                  <p role="status" class="mt-2 text-xs text-rose-600 dark:text-rose-400 bg-rose-50 dark:bg-rose-950/40 border border-rose-200 dark:border-rose-900/40 rounded-lg p-2">
                    La preparación necesita recuperación administrativa. Tu plaza y tu club se conservan.
                  </p>
                } @else if (league.capabilities && !league.capabilities.play) {
                  <p class="mt-2 text-xs text-amber-600 dark:text-amber-400 bg-amber-50 dark:bg-amber-950/30 border border-amber-200 dark:border-amber-900/30 rounded-lg p-2">
                    Las acciones de juego todavía no están habilitadas. Consulta el estado y las secciones disponibles.
                  </p>
                }
              </div>

              <div class="pt-2 border-t border-slate-100 dark:border-slate-800 flex items-center justify-end gap-2">
                @if (league.leagueState === 'ACTIVE') {
                  <button
                    type="button"
                    (click)="handleSelectPrivate(league)"
                    [id]="'btn-details-league-' + league.privateLeagueId"
                    title="Ver detalles de la liga"
                    aria-label="Ver detalles de la liga"
                    [disabled]="league.capabilities ? !league.capabilities.viewContext : game.isLeagueLoading()"
                    class="flex items-center space-x-1.5 px-3 py-2 rounded-xl text-xs font-semibold text-slate-700 dark:text-slate-200 bg-slate-100 hover:bg-slate-200 dark:bg-slate-800 dark:hover:bg-slate-700 border border-slate-200 dark:border-slate-700 transition-colors cursor-pointer disabled:opacity-50"
                  >
                    <app-icon name="info" [size]="14" />
                    <span>Detalles</span>
                  </button>

                  <button
                    type="button"
                    (click)="handleEnterPrivateClub(league)"
                    [id]="'btn-select-league-' + league.privateLeagueId"
                    [disabled]="(league.capabilities && !league.capabilities.play) || game.isLeagueLoading()"
                    class="flex items-center space-x-1.5 px-4 py-2 rounded-xl text-xs font-semibold text-white bg-purple-600 hover:bg-purple-700 active:bg-purple-800 shadow-xs transition-colors cursor-pointer disabled:opacity-50"
                  >
                    <span>Entrar a la Liga</span>
                    <app-icon name="arrow-right" [size]="14" />
                  </button>
                } @else {
                  <button
                    type="button"
                    (click)="handleSelectPrivate(league)"
                    [id]="'btn-select-league-' + league.privateLeagueId"
                    [disabled]="league.capabilities ? !league.capabilities.viewContext : game.isLeagueLoading()"
                    class="flex items-center space-x-1.5 px-4 py-2 rounded-xl text-xs font-semibold text-purple-700 dark:text-purple-200 bg-purple-50 dark:bg-purple-950 hover:bg-purple-100 dark:hover:bg-purple-900/80 border border-purple-200 dark:border-purple-700/60 transition-colors cursor-pointer disabled:opacity-50"
                  >
                    <span>{{league.leagueState === 'CANCELLED' ? 'Consultar liga' : 'Entrar a la Liga'}}</span>
                    <app-icon name="arrow-right" [size]="14" />
                  </button>
                }
              </div>
            </article>
          }
        </div>
      }
    </section>
  }

  <!-- Create League Modal -->
  @if (showCreateModal) {
    <div
      (click)="showCreateModal = false"
      class="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-xs p-4 cursor-pointer"
    >
      <div
        (click)="$event.stopPropagation()"
        class="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-2xl max-w-md w-full p-6 space-y-4 shadow-xl cursor-default"
      >
        <div class="flex items-center justify-between pb-3 border-b border-slate-100 dark:border-slate-800">
          <h3 class="text-lg font-bold text-slate-900 dark:text-white flex items-center space-x-2">
            <app-icon name="plus" [size]="18" class="text-emerald-600 dark:text-emerald-400" />
            <span>{{ game.t('leagues.create_modal_title') }}</span>
          </h3>
          <button (click)="showCreateModal = false" class="text-slate-400 hover:text-slate-700 dark:hover:text-white cursor-pointer">
            <app-icon name="x" [size]="18" />
          </button>
        </div>

        <form (ngSubmit)="handleCreateSubmit()" class="space-y-3 text-left">
          @if(errorMessage()) { <p role="alert">{{errorMessage()}}</p> }
          <div>
            <label class="block text-xs font-semibold text-slate-700 dark:text-slate-300 mb-1" for="create-league-name">
              {{ game.t('leagues.league_name_label') }}
            </label>
            <input
              id="create-league-name"
              type="text"
              required
              name="newLeagueName"
              [(ngModel)]="newLeagueName"
              placeholder="ej. Liga de los Colegas 2026"
              class="w-full px-3.5 py-2.5 bg-slate-50 dark:bg-slate-950 border border-slate-200 dark:border-slate-800 rounded-xl text-sm text-slate-900 dark:text-slate-100 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-emerald-500/20 focus:border-emerald-500"
            />
          </div>

          <div>
            <label class="block text-xs font-semibold text-slate-700 dark:text-slate-300 mb-1" for="create-club-name">
              {{ game.t('leagues.club_name_in_league') }}
            </label>
            <input
              id="create-club-name"
              type="text"
              required
              name="newPrivateClubName"
              [(ngModel)]="newPrivateClubName"
              placeholder="ej. Real Titanes FC"
              class="w-full px-3.5 py-2.5 bg-slate-50 dark:bg-slate-950 border border-slate-200 dark:border-slate-800 rounded-xl text-sm text-slate-900 dark:text-slate-100 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-emerald-500/20 focus:border-emerald-500"
            />
          </div>

          <div class="pt-3 flex items-center justify-end space-x-2 border-t border-slate-100 dark:border-slate-800">
            <button
              type="button"
              (click)="showCreateModal = false"
              class="px-4 py-2 rounded-xl text-xs font-semibold text-slate-700 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-800 cursor-pointer"
            >
              {{ game.t('common.cancel') }}
            </button>
            <button
              type="submit"
              id="btn-confirm-create-league"
              [disabled]="!privateLeaguesEnabled() || !newLeagueName.trim() || !newPrivateClubName.trim() || isSubmittingClub()"
              class="px-4 py-2 rounded-xl text-xs font-semibold text-white bg-emerald-600 hover:bg-emerald-700 disabled:opacity-50 cursor-pointer shadow-xs active:scale-98"
            >
              {{ game.t('leagues.create_and_join') }}
            </button>
          </div>
        </form>
      </div>
    </div>
  }

  <!-- Join League Modal -->
  @if (showJoinModal) {
    <div
      (click)="showJoinModal = false"
      class="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-xs p-4 cursor-pointer"
    >
      <div
        (click)="$event.stopPropagation()"
        class="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-2xl max-w-md w-full p-6 space-y-4 shadow-xl cursor-default"
      >
        <div class="flex items-center justify-between pb-3 border-b border-slate-100 dark:border-slate-800">
          <h3 class="text-lg font-bold text-slate-900 dark:text-white flex items-center space-x-2">
            <app-icon name="arrow-right" [size]="18" class="text-purple-600 dark:text-purple-400" />
            <span>{{ game.t('leagues.join_modal_title') }}</span>
          </h3>
          <button (click)="showJoinModal = false" class="text-slate-400 hover:text-slate-700 dark:hover:text-white cursor-pointer">
            <app-icon name="x" [size]="18" />
          </button>
        </div>

        <form (ngSubmit)="handleJoinSubmit()" class="space-y-3 text-left">
          @if(errorMessage()) { <p role="alert">{{errorMessage()}}</p> }
          <div>
            <label class="block text-xs font-semibold text-slate-700 dark:text-slate-300 mb-1" for="join-code">
              Enlace o código de invitación
            </label>
            <input
              id="join-code"
              type="text"
              required
              name="joinCode"
              [(ngModel)]="joinCode"
              placeholder="Pega el enlace de invitación" autocomplete="off" autocapitalize="none" spellcheck="false"
              class="w-full px-3.5 py-2.5 bg-slate-50 dark:bg-slate-950 border border-slate-200 dark:border-slate-800 rounded-xl text-sm text-slate-900 dark:text-slate-100 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-purple-500/20 font-mono"
            />
          </div>

          <div>
            <label class="block text-xs font-semibold text-slate-700 dark:text-slate-300 mb-1" for="join-club-name">
              {{ game.t('leagues.club_name_in_league') }}
            </label>
            <input
              id="join-club-name"
              type="text"
              required
              name="joinClubName"
              [(ngModel)]="joinClubName"
              placeholder="ej. Dragones FC"
              class="w-full px-3.5 py-2.5 bg-slate-50 dark:bg-slate-950 border border-slate-200 dark:border-slate-800 rounded-xl text-sm text-slate-900 dark:text-slate-100 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-purple-500/20"
            />
          </div>

          <div class="pt-3 flex items-center justify-end space-x-2 border-t border-slate-100 dark:border-slate-800">
            <button
              type="button"
              (click)="showJoinModal = false"
              class="px-4 py-2 rounded-xl text-xs font-semibold text-slate-700 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-800 cursor-pointer"
            >
              {{ game.t('common.cancel') }}
            </button>
            <button
              type="submit"
              id="btn-confirm-join-league"
              [disabled]="!privateLeaguesEnabled() || !joinCode.trim() || !joinClubName.trim() || isSubmittingClub()"
              class="px-4 py-2 rounded-xl text-xs font-semibold text-white bg-purple-600 hover:bg-purple-700 disabled:opacity-50 cursor-pointer shadow-xs active:scale-98"
            >
              {{ game.t('leagues.validate_and_enter') }}
            </button>
          </div>
        </form>
      </div>
    </div>
  }
    </div>
  </main>

  <!-- Modal de Ajustes & Wallet del Mánager -->
  <app-settings-modal
    [isOpen]="isSettingsModalOpen()"
    (closed)="closeSettingsModal()"
  />

  <footer class="border-t border-slate-200 dark:border-slate-800 py-4 text-center text-xs text-slate-500 dark:text-slate-400">
    <p>League of Managers · Selección de Liga Global y Ligas Privadas Multijugador</p>
  </footer>
</div>
